export const arrayToMap = <T extends object, K extends keyof any = keyof any, V = T>(
  arr: T[],
  getKey: (item: T) => K,
  getValue?: (item: T) => V,
): Partial<Record<K, V>> =>
  arr.reduce((map, item) => ({ ...map, [getKey(item)]: getValue ? getValue(item) : item }), {});
